if (!customElements.get('chalovelo-size-guide')) {
  customElements.define('chalovelo-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.dialog = this.querySelector('dialog');
      this.unit = 'in';
      this.onClick = this.handleClick.bind(this);
      this.root.addEventListener('click', this.onClick);
      this.onClose = () => {
        document.body.classList.remove('cv-size-open');
        const focusTarget = this.returnFocus?.isConnected ? this.returnFocus : this.root.querySelector('[data-cv-size-open]');
        focusTarget?.focus({ preventScroll: true });
      };
      this.dialog.addEventListener('close', this.onClose);
      this.unsubscribe = typeof subscribe === 'function'
        ? subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId === this.root.dataset.section) this.refresh();
          })
        : null;
      this.refresh();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.unsubscribe?.();
      document.body.classList.remove('cv-size-open');
    }

    handleClick(event) {
      if (event.target.closest('[data-cv-size-open]')) {
        this.returnFocus = event.target.closest('[data-cv-size-open]');
        this.loadSourceGuide();
        this.refresh();
        this.dialog.showModal();
        document.body.classList.add('cv-size-open');
      }
      if (event.target.closest('[data-cv-size-close]')) this.dialog.close();
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
      const unitButton = event.target.closest('[data-cv-unit]');
      if (unitButton) {
        this.unit = unitButton.dataset.cvUnit;
        this.refresh();
      }
      const sizeButton = event.target.closest('[data-cv-choose-size]');
      if (sizeButton) {
        const input = Array.from(this.root.querySelectorAll('input[data-cv-option-role="size"]'))
          .find((item) => item.value === sizeButton.dataset.cvChooseSize);
        if (!input) return;
        this.returnFocus = input;
        this.dialog.close();
        input.click();
      }
    }

    loadSourceGuide() {
      const fallback = this.querySelector('[data-cv-size-fallback]');
      if (!fallback || fallback.dataset.loaded) return;
      const description = document.querySelector('.cv-detail-specs .rte');
      const sourceTable = description?.querySelector('[data-cv-source-size-table]');
      const sourceImage = description?.querySelector('[data-cv-source-size-chart], img[alt$=" - size chart"]');
      if (!sourceTable && !sourceImage) return;
      const content = (sourceTable || sourceImage).cloneNode(true);
      if (sourceTable) {
        content.classList.add('cv-size-table');
        const labels = JSON.parse(this.root.querySelector('[data-cv-size-labels]')?.dataset.cvSizeLabels || '{}');
        content.querySelectorAll('thead th').forEach((heading) => {
          const key = heading.textContent.trim().toLowerCase().replace(/\s+/g, ' ');
          if (labels[key]) heading.textContent = labels[key];
        });
        const caption = content.querySelector('caption');
        if (caption && labels.caption) {
          caption.textContent = `${labels.caption}${content.dataset.cvUnit ? ` (${content.dataset.cvUnit})` : ''}`;
        }
        content.querySelectorAll('tbody tr').forEach((row) => {
          const first = row.querySelector('th,td');
          const size = first?.textContent.trim();
          const input = [...this.root.querySelectorAll('input[data-cv-option-role="size"]')].find((item) => item.value === size);
          if (!input) return;
          row.dataset.cvSizeRow = size;
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.cvChooseSize = size;
          button.textContent = size;
          first.replaceChildren(button);
        });
      } else {
        content.classList.add('cv-source-size-image');
        content.loading = 'eager';
      }
      fallback.replaceChildren(content);
      fallback.dataset.loaded = 'true';
      this.querySelector('.cv-size-toolbar').hidden = true;
    }

    refresh() {
      const selected = this.root.querySelector('input[data-cv-option-role="size"]:checked')?.value;
      this.querySelectorAll('[data-cv-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.cvUnit === this.unit));
      });
      this.querySelectorAll('[data-cv-cm]').forEach((cell) => {
        cell.textContent = this.unit === 'in' ? cell.dataset.cvIn : cell.dataset.cvCm;
      });
      this.querySelectorAll('[data-cv-size-row]').forEach((row) => {
        const active = row.dataset.cvSizeRow === selected;
        row.dataset.selected = String(active);
        row.querySelector('button')?.setAttribute('aria-pressed', String(active));
      });
      const currentRow = Array.from(this.querySelectorAll('[data-cv-size-row]'))
        .find((row) => row.dataset.cvSizeRow === selected);
      const sizeGroup = this.root.querySelector('.cv-option[data-cv-option-role="size"]');
      if (!sizeGroup) return;
      let summary = sizeGroup.querySelector('[data-cv-fit-summary]');
      if (!summary) {
        summary = document.createElement('p');
        summary.className = 'cv-fit-summary';
        summary.dataset.cvFitSummary = '';
        summary.setAttribute('aria-live', 'polite');
        sizeGroup.append(summary);
      }
      const measurements = currentRow
        ? Array.from(currentRow.querySelectorAll('[data-cv-measure]'))
            .map((cell) => `${cell.dataset.cvMeasureLabel || cell.dataset.cvMeasure} ${cell.textContent}`)
        : [];
      summary.textContent = measurements.length ? `${measurements.join(' / ')} ${this.unit}` : '';
    }
  });
}

window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-cv-checkout][aria-busy]').forEach((button) => {
    button.removeAttribute('aria-busy');
    const primary = button.closest('product-form')?.querySelector('[name="add"]');
    button.disabled = !primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true';
  });
});
